import HttpClientManager from '@/business/core/clients/http/helpers/manager.helper';
import type { BookingSuggestionRequest, JoinWaitlistPayload, getTimeOfBusinessParams, inquiryPaymentParmas } from '@/business/modules/request/request.model';
class RequestRepository {
	httpClient: any;
	static #instance: RequestRepository;
	readonly REQUEST_USER: string = 'ReserveTimesReceipt/Users';
	readonly REQUEST_BUSINESS: string = 'ReserveTimesReceipt/Businesses';
	readonly REQUEST: string = 'ReserveTimesReceipt';
	readonly REQUEST_SENDER: string = 'ReserveTimesSender';

	private constructor() {
		this.httpClient = HttpClientManager.getInstance();
	}

	public static getInstance(): RequestRepository {
		if (!RequestRepository.#instance) {
			RequestRepository.#instance = new RequestRepository();
		}

		return RequestRepository.#instance;
	}

	getAcceptedRequestsUser(isFinished: boolean, page: number, size: number): Promise<any> {
		return this.httpClient(`${this.REQUEST_USER}/Finished/${isFinished}/Page/${page}/Size/${size}`, {
			method: 'get',
		});
	}

	getReserveTimeUser(state: 0 | 1 | 2, page: number, size: number): Promise<any> {
		return this.httpClient(`${this.REQUEST_USER}/State/${state}/Page/${page}/Size/${size}`, {
			method: 'get',
		});
	}

	getReserveTimeInBusinessBook(state: 0 | 1 | 2, page: number, size: number): Promise<any> {
		return this.httpClient(`${this.REQUEST_BUSINESS}/State/${state}/Page/${page}/Size/${size}`, {
			method: 'get',
		});
	}

	getAcceptedRequestsInBusinessBook(isFinished: boolean, page: number, size: number): Promise<any> {
		return this.httpClient(`${this.REQUEST_BUSINESS}/Finished/${isFinished}/Page/${page}/Size/${size}`, {
			method: 'get',
		});
	}

	setReserveStatus(id: number | string, state: 0 | 1 | 2): Promise<any> {
		return this.httpClient(`${this.REQUEST}/${id}/State/${state}`, {
			method: 'put',
			isShowNotify: true,
		});
	}

	markNoShow(id: number | string): Promise<any> {
		return this.httpClient(`${this.REQUEST}/${id}/NoShow`, {
			method: 'put',
			isShowNotify: true,
		});
	}

	cancelReserve(id: number | string): Promise<any> {
		return this.httpClient(`${this.REQUEST}/${id}/Cancel`, {
			method: 'put',
			isShowNotify: true,
		});
	}

	getBookingSuggestions(data: BookingSuggestionRequest) {
		return this.httpClient(`${this.REQUEST}/Suggestions`, {
			method: 'post',
			data,
			isShowNotify: true,
		});
	}

	joinWaitlist(data: JoinWaitlistPayload) {
		return this.httpClient(`${this.REQUEST}/Waitlist`, {
			method: 'post',
			data,
			isShowNotify: true,
		});
	}

	getWaitlistOffer(token: string): Promise<any> {
		return this.httpClient(`${this.REQUEST}/Waitlist/Offer`, {
			method: 'get',
			params: { token },
		});
	}

	redirectToPayment(data: object) {
		return this.httpClient(`${this.REQUEST}/Direct`, {
			method: 'post',
			data: data,
		});
	}

	reserveWithoutPayment(data: object) {
		return this.httpClient(`${this.REQUEST}/WithoutPayment`, {
			method: 'post',
			data: data,
			isShowNotify: true,
		});
	}

	payWithWallet(data: object) {
		return this.httpClient(`${this.REQUEST}/Wallet`, {
			method: 'post',
			data: data,
			isShowNotify: true,
		});
	}

	inquiryPayment(data: inquiryPaymentParmas): Promise<any> {
		let { id, rrn, authority } = data;
		rrn = rrn?.trim() ? rrn : null;
		authority = authority?.trim() ? authority : null;

		return this.httpClient(`${this.REQUEST}/${id}/Inquiry`, {
			method: 'get',
			params: {
				rrn,
				authority,
			},
		});
	}

	getRequestDetail(requestId: string, source: 'receive' | 'send' = 'receive'): Promise<any> {
		const resource = source === 'send' ? this.REQUEST_SENDER : this.REQUEST;
		return this.httpClient(`${resource}/${requestId}`, {
			method: 'get',
		});
	}

	getTimeOfBusiness(data: getTimeOfBusinessParams): Promise<any> {
		const { businessId, day, minute } = data;
		return this.httpClient(`${this.REQUEST_BUSINESS}/${businessId}`, {
			method: 'get',
			params: {
				day,
				minute,
			},
		});
	}
}

export default RequestRepository;
